import React, { Component } from "react";
import "../../assets/sass/legal.scss";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

import Navbar from "../global-components/navbar-v4";
import PageHeader from "../global-components/page-header";

import CallToActionV1 from "../section-components/call-to-action-v1";
import SponsorV2 from "../section-components/sponsor-v2";
import Footer from "../global-components/footer";

class Legal extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div>
        <div className="legal-details-page ltn__page-details-area ltn__legal-details-page-area mb-105">
          <Navbar />
          <div className="legal-details-page__legal-details-page-header">
            <h1 className="legal-details-page__project-title">Legal</h1>
          </div>

          {/* <PageHeader headertitle="Portfolio 1" /> */}

          <div className="legal-details-page__container container w-100">
            <div className="row">
              <p>
                {" "}
                <span className="ltn__first-letter">Q</span>uoin Management
                provides legal assistance to its clients as part of its
                services. Legal help is an important aspect of property
                management as it can help protect the interests of both the
                property owner and the tenants. Here are some ways in which
                Quoin Management can provide you with legal help:
              </p>

              <p>
                Ending a Tenancy: If you need to end a tenancy, we can guide you
                through the correct legal process. We make sure the right notice is
                served on the right grounds, keep the records and evidence you will
                need, and work with a solicitor if the case goes to court. Only a
                court can order a tenant to leave, so getting the process right from
                the start avoids costly delays.
              </p>
              <p>
                Tenant Disputes: Quoin Management can help landlords resolve
                disputes with tenants, such as disputes over rent payments or
                property damage. We can negotiate with tenants on behalf of
                the landlord and try to resolve the dispute without going to
                court.
              </p>
              <p>
                Compliance with the Law: Quoin Management can help landlords meet
                their legal obligations, including repairing standards, safety
                certificates, deposit protection and the changes introduced by the
                Renters' Rights Act 2025.
              </p>
            </div>
            <div className="row mt-4 mb-4 reverse-columns">
              <div className="col-lg-6">
                <img
                  src={publicUrl + "assets/img/service/legal-2.jpg"}
                  alt="Legal services"
                />
              </div>
              <p className="col-lg-6">
                <h1> Drafting and reviewing leases </h1>
                Quoin Management can help landlords draft and review leases and
                tenancy agreements that comply with current law. This can ensure that the lease
                protects the landlord's rights and interests while also ensuring
                that tenants are aware of their obligations.
              </p>
            </div>
            <div className="row mt-3 mb-5">
              <p className="col-lg-6 ">
                <h1> Buying or Selling a Property </h1>
                Buying or selling a property can be complex, so we can introduce
                you to a regulated conveyancing solicitor to handle the legal
                work. We will work alongside them on your behalf, providing the
                information they need about the property and keeping you updated
                throughout.
              </p>
              <div className="col-lg-6">
                <img
                  src={publicUrl + "assets/img/service/legal-3.jpg"}
                  alt="Legal services"
                />
              </div>
            </div>
            <div className="row mt-4 mb-4 reverse-columns">
              <div className="col-lg-6">
                <img
                  src={publicUrl + "assets/img/service/legal-4.jpg"}
                  alt="Legal services"
                />
              </div>
              <p className="col-lg-6">
                <h1> Property Inspection</h1>
                Quoin Management can conduct regular property inspections to
                ensure that the property is safe for tenants and meets current
                legal and health and safety standards.
              </p>
            </div>
          </div>

          <SponsorV2 />
          <CallToActionV1 />
          <Footer />
        </div>
      </div>
    );
  }
}

export default Legal;
